import { useTranslations } from 'next-intl';
import { BorderContainer } from '../../../../../BorderContainer/BorderContainer';
import { LotteryHeaderContainer } from '../../../../../LotteryHeaderContainer/LotteryHeaderContainer';
import { usePrizeTablesContext } from '../../context';

const EXTRA_GAME_CONTAINER_OPTIONS = {
  decorationShine: 'hidden',
  decorationTopRight: 'hidden',
} as const;

/**
 * TableHeadlinePowerPlay component displays the headline for a power play game (use in PowerBall & MegaMillions).
 * @param selectedId - The ID of the currently selected prize table.
 * @returns  The rendered TableHeadlinePowerPlay component.
 */
function TableHeadlinePowerPlay({ selectedId }: { selectedId: string }) {
  const { lotteryName, namespace, extraGames } = usePrizeTablesContext();
  const t = useTranslations(namespace);

  const selectedExtraGame = extraGames?.find(game => game.name === selectedId);
  const selectedNumber = selectedExtraGame?.numbers?.[0];

  return (
    <LotteryHeaderContainer lotteryName={lotteryName} className="h-auto p-5 rounded-lg" options={EXTRA_GAME_CONTAINER_OPTIONS}>
      <BorderContainer className="light ll-container-full px-7.5 py-3 paragraph-strong text-foreground">
        <span>{t(`extra_game_${selectedId}`)}</span>
        <span>{selectedNumber ?? '-'}</span>
      </BorderContainer>
    </LotteryHeaderContainer>
  );
}

export { TableHeadlinePowerPlay };
